export default "__VITE_ASSET__2d8d72a4__"